import {
  typedCollection,
  typedDoc,
  getCollection,
  getDocument,
  orderBy,
  where,
} from '@/lib/firebase/firestore'
import type { SeasonDocument, FilmDocument } from '@/types'

const seasonsCol = () => typedCollection<SeasonDocument>('seasons')
const filmsCol = () => typedCollection<FilmDocument>('films')

export const seasonsService = {
  async getPublishedSeasons(): Promise<Array<SeasonDocument & { id: string }>> {
    return getCollection(seasonsCol(), where('isPublished', '==', true), orderBy('order', 'asc'))
  },

  async getFilmsBySeason(seasonNumber: number): Promise<Array<FilmDocument & { id: string }>> {
    const all = await getCollection(
      filmsCol(),
      where('seasonNumber', '==', seasonNumber),
      where('isPublished', '==', true),
      orderBy('order', 'asc')
    )
    return all.filter(f => (f.type ?? 'episode') === 'episode')
  },

  async getProjects(): Promise<Array<FilmDocument & { id: string }>> {
    return getCollection(
      filmsCol(),
      where('type', '==', 'project'),
      where('isPublished', '==', true),
      orderBy('order', 'asc')
    )
  },

  async getFilmBySlug(slug: string): Promise<(FilmDocument & { id: string }) | null> {
    const results = await getCollection(filmsCol(), where('slug', '==', slug), where('isPublished', '==', true))
    return results[0] ?? null
  },

  async getLatestFilm(): Promise<(FilmDocument & { id: string }) | null> {
    const results = await getCollection(
      filmsCol(),
      where('isPublished', '==', true),
      orderBy('createdAt', 'desc')
    )
    return results[0] ?? null
  },

  async getSeasonById(id: string): Promise<(SeasonDocument & { id: string }) | null> {
    return getDocument(typedDoc<SeasonDocument>('seasons', id))
  },
}
